import { useControllableValue } from 'ahooks';
import { InputProps } from 'antd';
import classNames from 'classnames';
import React from 'react';
import SwapRight from '@/assets/images/icons/SwapRight.react.svg?react';
import { BaseFormItemProps, PropsWithStyles } from '@/presentation/components/tds-form/type';
import './index.module.scss';
import { TdsFieldSelector, TdsFieldSelectorProps } from '../tds-field-selector';

export interface TdsCharacterRangeProps<T = any> extends BaseFormItemProps<T> {
  minInputProps?: InputProps;
  maxInputProps?: InputProps;
  valueSelectProps?: TdsFieldSelectorProps;
}

export type TdsCharacterRangeValue = {
  min?: string;
  max?: string;
};

export const TdsCharacterRange = (props: PropsWithStyles<TdsCharacterRangeProps>) => {
  const [value, setValue] = useControllableValue<TdsCharacterRangeValue>(props, {
    defaultValue: {
      min: undefined,
      max: undefined,
    },
  });

  const onMinValueChange = (minValue: any) => {
    setValue({
      max: value?.max,
      min: minValue,
    });
  };

  const onMaxValueChange = (maxValue: any) => {
    setValue({
      min: value?.min,
      max: maxValue,
    });
  };

  return (
    <div className={classNames('tds-character-range', props.className)} style={props.style}>
      <TdsFieldSelector
        className='overflow-hidden'
        value={value?.min}
        onChange={onMinValueChange}
        showArrow={false}
        {...props.valueSelectProps}
      />
      <SwapRight/>
      <TdsFieldSelector
        className='overflow-hidden'
        value={value?.max}
        onChange={onMaxValueChange}
        showArrow={false}
        {...props.valueSelectProps}
      />
    </div>
  );
};
